import { Icon, IconStyleProps } from "@nju/icons";
import { Text, TextStyleProps } from "@nju/ui";

interface IUserNameProps {
  userName: string | undefined;
  textTone: TextStyleProps["tone"];
  iconTone: IconStyleProps["tone"];
}

export function UserName({ userName, textTone, iconTone }: IUserNameProps) {
  return (
    <div className="flex items-center pr-5">
      <Icon height={24} name="briefcase" tone={iconTone} width={24} />
      <div className="ml-2">
        {userName && <Text tone={textTone}>{userName}</Text>}
      </div>
    </div>
  );
}
